// extracted by mini-css-extract-plugin
module.exports = {"header":"ConsoTable_header__Wtg15","table":"ConsoTable_table__2XUBN"};